import { AppPaths } from "@/shared/common/enums";
import { useAppSelector } from "@/shared/hooks";
import { Navigate } from "react-router-dom";

export const NotFound = () => {
  const isAuth = useAppSelector((state) => state.auth.isAuth);

  if (isAuth) {
    return <Navigate to={AppPaths.Dashboard} replace/>;
  }
  return <Navigate to={AppPaths.Login} replace/>;
};
